import React from 'react';
import House5 from './Assets/Images/House5.webp';

const AboutUs = () => {
  return (
    <div className="min-h-[75vh] px-4 md:px-12 lg:px-15 py-8">
      <div className="flex flex-col lg:flex-row items-center h-full">
        
        {/* Left: Image */}
        <div className="w-full lg:w-1/2 h-full mb-6 lg:mb-0" data-aos="fade-right">
          <img
            src={House5}
            alt="House"
            className="w-full h-[95vh] object-cover rounded-md"
          />
        </div>

        {/* Right: Text */}
        <div className="w-full lg:w-1/2 lg:pl-10 space-y-6">
          <h1 className="text-black text-3xl md:text-4xl font-bold font-sans" data-aos="fade-right">
            Welcome to Ram Engineer
          </h1>

          <h2 className="text-black text-lg md:text-xl font-semibold font-sans" data-aos="fade-right" data-aos-delay="300">
            Designing Dreams / Building Realities
          </h2>

          <p data-aos="fade-right" data-aos-delay="500">
            <b>Ram Engineer</b> offers end-to-end <b>design and build services</b> that transform your vision into beautifully crafted, functional, and lasting spaces.
          </p>

          <p data-aos="fade-right" data-aos-delay="700">
            At <b>Ram Engineer</b>, we specialize in providing <b>Construction and Interior Design</b> that offer clients a seamless experience from concept to completion. Whether you’re building a new space, renovating an existing one, or redesigning interiors, our expertise spans both design and construction. Our goal is to create <b>functional, aesthetic, and sustainable</b> spaces that elevate your environment and match your unique lifestyle.
          </p>

          <p data-aos="fade-right" data-aos-delay="900">
            We offer a comprehensive suite of services designed to cater to both Construction and Interior Design needs. Whether you are embarking on a <b>residential, commercial, or renovation</b> project, we ensure that each aspect of your space—design, construction, and functionality—is carefully crafted to meet your needs.
          </p>

          <button className="mt-4 bg-black text-white w-40 h-10 rounded hover:bg-gray-800 transition">
            <b>Get quote</b>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
